var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "form",
          {
            attrs: { novalidate: "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _vm._m(0),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "ml-3",
                      attrs: { variant: "primary", text: "Link SSO" }
                    },
                    _vm._l(_vm.externalLoginOptions, function(loginOption) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: loginOption.id,
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.externalSignIn(loginOption)
                            }
                          }
                        },
                        [
                          loginOption.loginMethod ===
                          _vm.loginMethodsConstant.Microsoft
                            ? _c("i", { staticClass: "fa-brands fa-windows" })
                            : loginOption.loginMethod ===
                              _vm.loginMethodsConstant.Okta
                            ? _c("i", [
                                _c("object", {
                                  staticStyle: { height: "12px" },
                                  attrs: {
                                    data: "/img/SSOLogos/okta.svg",
                                    type: "image/svg+xml"
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(
                            " Link " + _vm._s(loginOption.name) + " Account "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("h2", { attrs: { id: "title-of-block-check" } }, [
          _vm._v("Setup SSO")
        ]),
        _c("div", { staticClass: "alert alert-info small" }, [
          _vm._v(
            "Your administrator requires users to use a SSO provider, as you have not been setup yet, please follow these steps to do so."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }